import { ApolloError } from '@apollo/client';

export type GenericError = Error &
  Partial<Omit<ApolloError, keyof Error>> & {
    displayMessage?: string;
    reason?: string;
  };

export const isGenericError = (error: unknown): error is GenericError =>
  typeof (error as GenericError)?.message === 'string';
